export const staticFunctions = {
  addDevicesClasses() {
    var body = document.getElementsByTagName("BODY")[0];
    body.classList.add((typeof document.body.ontouchstart == "undefined") ? "no-touch" : "touch");
    if ((/iP/i.test(navigator.userAgent)))
        body.classList.add("ios");
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js